import { render, staticRenderFns } from "./MailList.vue?vue&type=template&id=758b61ee&scoped=true"
import script from "./MailList.vue?vue&type=script&lang=js"
export * from "./MailList.vue?vue&type=script&lang=js"
import style0 from "./MailList.vue?vue&type=style&index=0&id=758b61ee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "758b61ee",
  null
  
)

export default component.exports